export default __webpack_public_path__ + "static/media/bannerMini2.580dbea8.jpg";